import { ChangeDetectorRef, Component, ElementRef, forwardRef, Inject, KeyValueDiffers, OnChanges, OnInit } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';

import { UserPreferencesService } from '../../../../Account/UserPreferences/services/user-preferences.service';
import { ProminenceLockerService } from '../../../Misc/services/prominence-locker.service';
import { MonitorConfigService } from '../../../MonitorShared/services/monitor-config.service';
import { BlockComponent } from '../../../PageBuilder/components/Block/block.component';
import { AbstractPageBuilderService } from '../../../PageBuilder/services/abstract-page-builder.service';
import { ClickOutsideService } from '../../../PageBuilder/services/click-outside.service';
import { TopMentionsChartBlockComponent } from '../../../Reports/components/TopMentions/TopMentionsChartBlock/top-mentions-chart-block.component';
import { ReportsSeriesPreviewService } from '../../../Reports/services/report-series-preview.service';
import { ReportsChartDetailService } from '../../../Reports/services/reports-chart-detail.service';
import { ReportsChartOptionsService } from '../../../Reports/services/reports-chart-options.service';
import { ConfigService } from '../../../../Core/Config/services/config.service';
import { LocalizationService } from '../../../../Core/Localization/services/localization.service';
import { CurrencyConversionService } from '../../../../Core/Users/services/currency-conversion.service';
import { CurrentUserStateService } from '../../../../Core/Users/services/current-user-state.service';
import { SocialChartDetailsDialogService } from '../../../../Social/Intelligence/services/social-chart-details-dialog.service';
import { DataConnectionService } from '../../../../Core/Users/services/data-connection.service';
import { ReportsChartSeriesConverterService } from '../../../Reports/services/reports-chart-series-converter.service';
import { ReportsSeriesPreviewNewService } from '../../../../Common/Reports/services/reports-series-preview-new.service';


@Component({
    selector: 'agpr-dashboard-top-mentions-chart-block',
    templateUrl: './dashboard-top-mentions-chart-block.component.html',
    styleUrls: ['./dashboard-top-mentions-chart-block.component.scss'],
    providers: [
        {
            provide: BlockComponent,
            useExisting: forwardRef(() => DashboardTopMentionsChartBlockComponent)
        }
    ],
    standalone: false
})
export class DashboardTopMentionsChartBlockComponent extends TopMentionsChartBlockComponent implements OnInit, OnChanges {

    constructor(
        public differs: KeyValueDiffers,
        public pageBuilderService: AbstractPageBuilderService,
        public reportSeriesPreviewService: ReportsSeriesPreviewService,
        public reportsChartOptionsService: ReportsChartOptionsService,
        public localizationService: LocalizationService,
        @Inject(APP_BASE_HREF) public appBaseHref: string,
        public cdr: ChangeDetectorRef,
        public userStateService: CurrentUserStateService,
        public prominenceLockerService: ProminenceLockerService,
        public monitorConfigService: MonitorConfigService,
        protected userPreferencesService: UserPreferencesService,
        public clickOutsideService: ClickOutsideService,
        public reportsChartDetailService: ReportsChartDetailService,
        public socialChartDetailsDialogService: SocialChartDetailsDialogService,
        public configService: ConfigService,
        public el: ElementRef,
        public currencyConversionService: CurrencyConversionService,
        public dataConnectionService: DataConnectionService,
        public chartOptionsService: ReportsChartOptionsService,
        public reportsChartSeriesConverterService: ReportsChartSeriesConverterService,
        public reportsSeriesPreviewNewService: ReportsSeriesPreviewNewService
    ) {
        super(
            differs,
            pageBuilderService,
            reportSeriesPreviewService,
            reportsChartOptionsService,
            localizationService,
            appBaseHref,
            cdr,
            userStateService,
            prominenceLockerService,
            monitorConfigService,
            userPreferencesService,
            clickOutsideService,
            reportsChartDetailService,
            socialChartDetailsDialogService,
            configService,
            el,
            currencyConversionService,
            dataConnectionService,
            reportsChartSeriesConverterService,
            reportsSeriesPreviewNewService
        );
    }
}
